export const getPathname = (route)=>{
    const url = new URL(route, 'https://www.lichtblick.de');
    let pathname = url.pathname;
    if (!pathname.endsWith('/')) {
        pathname += '/';
    }
    return pathname;
};

//# sourceMappingURL=get-pathname.js.map